export const setupRingtone = (audioUrl: string, loop: boolean, outputId: string | null): HTMLAudioElement => {
  const audio = new Audio(audioUrl);
  audio.loop = loop;

  if (outputId && 'setSinkId' in audio) {
    // setSinkId() is async; swallow benign AbortError if torn down mid-switch.
    (audio as any).setSinkId(outputId).catch((e: unknown) => {
      console.error('Setting ringtone sink Id to', outputId, 'failed', e);
    });
    console.log('Ringtone sink id set to', outputId);
  } else if (outputId) {
    console.error("Can't set ringtone sink id");
  }

  return audio;
};
